<template>
    <div class="row bg-light rounded p-5">
        <div class="card bg-success rounded p-3">
            <h3 class="text-white" v-if="nomineePanel == 'nominee-panel'">{{ $t("Nominee Panel") }}</h3>
            <h3 class="text-white" v-else>{{ $t("Witness Panel") }}</h3>
        </div>
        <div class="accordion accordion-flush mt-4" id="accordionExample">

            <div class="accordion-item mt-4" v-if="key.includes('Zakat Info')">
                <h2 class="accordion-header" id="headingOne">
                    <a class="accordion-button text-decoration-none collapsed bg-success text-warning fw-bold rounded"
                       type="button"
                       data-bs-toggle="collapse"
                       data-bs-target="#collapseOne"
                       aria-expanded="false"
                       aria-controls="collapseOne">
                        {{ $t("Last Zakat Info") }}
                    </a>
                </h2>
                <div id="collapseOne"
                     class="accordion-collapse collapse"
                     aria-labelledby="headingOne"
                     data-bs-parent="#accordionExample">

                    <div class="accordion-body">
                        <div class="col-md-12 mt-2">
                            <div class="card shadow-sm zakat p-1 h-100">
                                <div class="card-header text-center bg-primary text-white rounded-3 mt-2">
                                    <h6 class="card-title mb-0 fw-bold">{{ $t("Last Zakat Info") }}</h6>
                                </div>
                                <div class="card-body fw-bold text-secondary">
                                    <div class="row">
                                        <div class="col-md-4 text-center mb-md-0">
                                            <div class="zakat-info-item">
                                                <h6 class="zakat-label">{{ $t("Total Assets") }}:</h6>
                                                <p class="zakat-data">
                                                    {{ getZakatData?.currencyCode && getZakatData?.totalAsset ?
                                                    getZakatData?.currencyCode +': '+getZakatData?.totalAsset
                                                    : 'No Data Found!' }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-4 text-center mb-md-0">
                                            <div class="zakat-info-item">
                                                <h6 class="zakat-label">{{ $t("Zakat Payable Amount") }}:</h6>
                                                <p class="zakat-data">{{ getZakatData && getZakatData?.currencyCode &&
                                                    getZakatData?.zakatAmount
                                                    ? getZakatData?.currencyCode + ': ' + getZakatData?.zakatAmount
                                                    : 'No Data Found'
                                                    }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-4 text-center mb-md-0">
                                            <div class="zakat-info-item">
                                                <h6 class="zakat-label">{{ $t("Last Modify Date") }}:</h6>
                                                <p class="zakat-data">{{lastCalculateFormatted && lastCalculateFormatted
                                                    ? lastCalculateFormatted : 'No Data Found'}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="accordion-item mt-4" v-if="key.includes('Asset Calculation Info')">
                <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed bg-success text-warning fw-bold rounded"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo">
                        {{ $t("Property Distribution Section") }}
                    </button>
                </h2>
                <div id="collapseTwo"
                     class="accordion-collapse collapse"
                     aria-labelledby="headingTwo"
                     data-bs-parent="#accordionExample">

                    <div class="accordion-body">
                        <div class="card-header text-center bg-primary text-white rounded-3 mt-2">
                            <h4 class="card-title mb-0 fw-bold p-2">{{ $t("Property Distribution Section") }}</h4>
                        </div>
                        <div class="container-fluid bg-white rounded">
                            <div class="row">
                                <!-- Paginated Sections (Each Page Contains 25 Lines) -->
                                <div class="container-fluid" id="content">
                                    <div class="row justify-content-center">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="border-property p-3">
                                                <div class="relative-property d-flex justify-content-between">
                                                    <h3 id="relative-heading">
                                                        <i class="fa-solid fa-gift">&nbsp;&nbsp;</i
                                                        >{{ $t("Property Distribution Result") }}
                                                    </h3>
                                                </div>
                                                <div class="row">
                                                    <!-- Labels Div -->
                                                    <div class="col-md-6 mt-5 m-auto text-center">
                                                        <div>
                                                            <div
                                                                    v-for="(label, index) in propertyDistributionData"
                                                                    :key="index"
                                                                    class="fw-bold text-center"
                                                            >
                                                                <span :style="{ color: existingChartOptions.colors[index] }">●</span>
                                                                {{ label.relative_name + " - " + label.portion_part }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Chart Div -->
                                                    <div class="col-md-6 mt-4">
                                                        <div id="chart">
                                                            <apexchart
                                                                    v-if="series && series.length && existingChartOptions.labels && existingChartOptions.labels.length"
                                                                    type="pie"
                                                                    width="380"
                                                                    :options="existingChartOptions"
                                                                    :series="series"
                                                            ></apexchart>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-8 m-auto">
                                                        <div
                                                                class="row child-division mt-2"
                                                                v-for="f in propertyDistributionData"
                                                                :key="f"
                                                        >
                                                            <h2 class="mt-2">{{ f.relative_name }}</h2>
                                                            <div class="custom-table shadow-xl">
                                                                <div>
                    <span class="fw-bold">
                      <p>{{ $t("LAND") }}</p>
                      <p class="unit">({{ $t("DECIMAL") }})</p>
                    </span>

                                                                    <p class="values mt-4">{{ f.land_part }}</p>
                                                                </div>
                                                                <div>
                    <span class="fw-bold">
                      <p>{{ $t("GOLD") }}</p>
                      <p class="unit">({{ $t("Vori") }})</p>
                    </span>

                                                                    <p class="values mt-4">{{ f.gold_part }}</p>
                                                                </div>
                                                                <div>
                    <span class="fw-bold">
                      <p>{{ $t("SILVER") }}</p>
                      <p class="unit">({{ $t("Vori") }})</p>
                    </span>

                                                                    <p class="values mt-4">{{ f.silver_part }}</p>
                                                                </div>
                                                                <div>
                    <span class="fw-bold">
                      <p>{{ $t("CURRENCY") }}</p>
                      <p class="unit">({{ $t("TAKA") }})</p>
                    </span>

                                                                    <p class="values mt-4">{{ f.currency_part }}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="accordion-item mt-4" v-if="key.includes('Wasiyyah Preview')">
                <h2 class="accordion-header" id="headingThree">
                    <button class="accordion-button collapsed bg-success text-warning fw-bold rounded"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree">
                        {{ $t("Wasiyyah Preview") }}
                    </button>
                </h2>
                <div id="collapseThree"
                     class="accordion-collapse collapse"
                     aria-labelledby="headingThree"
                     data-bs-parent="#accordionExample">

                    <div class="accordion-body">
                        <div class="card-header text-center bg-primary text-white rounded-3 mt-2">
                            <h4 class="card-title mb-0 fw-bold p-2">{{ $t("Wasiyyah Preview") }}</h4>
                        </div>
                        <div class="container-fluid bg-white rounded">
                            <div class="row">
                                <!-- Paginated Sections (Each Page Contains 25 Lines) -->
                                <div
                                        class="col-12 col-md-10 mt-4 mx-auto"
                                        v-for="(page, pageIndex) in paginatedContent"
                                        :key="pageIndex"
                                >
                                    <div class="border rounded p-3" id="printable-section">
                                        <div class="row align-items-center" v-if="pageIndex === 0">
                                            <!-- First Section with QR Code and Barcode -->
                                            <div class="col-12" style="background: antiquewhite">
                                                <div class="row mt-5">
                                                    <!-- Bar Code -->
                                                    <div class="col-6 col-md-2 d-flex flex-column justify-content-center mt-5">
                                                        <BarcodePage class="vertical-barcode img-fluid"/>
                                                    </div>
                                                    <!-- Centered Image -->
                                                    <div class="col-6 col-md-8 d-flex flex-column align-items-center mb-3">
                                                        <img
                                                                src="@/assets/images/circle.png"
                                                                alt="First Page Image"
                                                                class="img-fluid"
                                                                style="max-width: 100%; height: auto;">
                                                    </div>
                                                    <!-- QR code -->
                                                    <div class="col-6 col-md-2 d-flex flex-column justify-content-center mt-5">
                                                        <QRCode class="img-fluid"/>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Second Section with Bismillah Image -->
                                            <div class="col-12 text-center">
                                                <img
                                                        src="@/assets/images/bismillah.png"
                                                        alt="First Page Image"
                                                        class="img-fluid"
                                                        style="max-width: 60%; height: auto;">
                                            </div>
                                        </div>

                                        <!-- Other pages -->
                                        <div class="col-12 text-center mt-3" v-else
                                             style="background-color: antiquewhite; padding: 10px;">
                                            <img
                                                    src="@/assets/images/wasiyah.png"
                                                    alt="Other Pages Image"
                                                    class="img-fluid"
                                                    style="max-width: 100%; height: auto;">
                                        </div>

                                        <!-- Dynamic Content for Each Page -->
                                        <div class="preview mt-4">
                                            <div v-for="(item, index) in page" :key="index">
                                                <h6 class="text-center p-1">{{ item.title }}</h6>
                                                <hr class="style-seven m-auto">
                                                <p class="text-justify p-3">{{ item.content }}</p>
                                            </div>
                                        </div>

                                        <!-- Footer with Page Number -->
                                        <footer class="text-center mt-3 p-2"
                                                style="background-color: #fff6ed; color: grey;">
                                            Page {{ pageIndex + 1 }} of {{ totalPages }}
                                        </footer>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiRepository from "@/services/ApiRepository";
    import BarcodePage from "@/components/layouts/views/chart/BarCode";
    import QRCode from "@/components/layouts/views/chart/QRCode";
    // import {toast} from "vue3-toastify";
    // import { useRoute } from 'vue-router'

    export default {
        name: "nomineePanel",
        components: {
            BarcodePage,
            QRCode
        },
        
        data() {
            return {
                lastCalculateFormatted: null,
                propertyDistributionData: [],
                getZakatData: [],
                propertyResult: [],
                key: [],
                linesPerPage: 21,
                nomineePanel: '',
                wasiyyahPreviewOptions: [],
                existingChartOptions: {
                    chart: {
                        type: "pie",
                    },
                    labels: [],
                    colors: [],
                },
                series: [],
                legend: {
                    show: false,
                },
            }
        },
        computed: {
            totalPages() {
                return Math.ceil(this.getTotalLines() / this.linesPerPage);
            },
            paginatedContent() {
                const pages = [];
                let currentPage = [];
                let currentLines = 0;

                for (let item of this.wasiyyahPreviewOptions) {
                    const itemLines = item.content.split("\n").length + 2; // Including title lines
                    if (currentLines + itemLines > this.linesPerPage) {
                        pages.push(currentPage); // Save full page
                        currentPage = []; // Start new page
                        currentLines = 0;
                    }
                    currentPage.push(item);
                    currentLines += itemLines;
                }

                if (currentPage.length) {
                    pages.push(currentPage); // Push remaining items
                }

                return pages;
            },

        },
        mounted() {
            const requestKey = this.$route.params.id
            this.getUserContextVerify(requestKey);
            this.getHeading()

        },

    watch: {
        $route(to) {
            const requestKey = to.params.id;

            // reset state (VERY IMPORTANT)
            this.resetData();

            // reload everything
            this.getUserContextVerify(requestKey);
            this.getHeading();
        }
    },
        methods: {
            getHeading() {
                // const url = window.location.pathname;
                // const parts = url.split('/');

                // this.nomineePanel = parts[2];
                this.nomineePanel = this.$route.name;
            },
            resetData() {
                this.lastCalculateFormatted = null;
                this.propertyDistributionData = [];
                this.getZakatData = [];
                this.propertyResult = [];
                this.key = [];
                this.wasiyyahPreviewOptions = [];
                this.series = [];
                this.existingChartOptions = {
                    chart: { type: "pie" },
                    labels: [],
                    colors: [],
                };
            },
            contextDataGet(key) {
                try {
                    apiRepository.getContextData(key).then((res) => {
                        if (res.data) {
                            this.getZakatData = res.data?.zakat;
                            this.wasiyyahPreviewOptions = Array.isArray(res.data?.wasiyyahContent)
                                ? res.data.wasiyyahContent.filter(item => item.visible === "Y")
                                : [];
                            // this.wasiyyahPreviewOptions = res.data?.wasiyyahContent.filter((item) => item.visible == "Y");
                        }
                        if (res.data?.propertyResult) {
                            this.propertyDistributionData = JSON.parse(res.data?.propertyResult);
                        }

                        let seriesData = [];
                        let labelsData = [];
                        seriesData = this.propertyDistributionData.map((item) => {
                            const portionPart = this.castToInteger(item.portion_part);

                            if (isNaN(portionPart) || portionPart === null) {
                                return 0;
                            }
                            return portionPart;
                        });

                        labelsData = this.propertyDistributionData.map((item) => {
                            const relativeName = item.relative_name || "Unknown";
                            return relativeName;
                        });

                        // Check if data is valid before updating the chart
                        if (seriesData.length > 0 && labelsData.length > 0) {
                            this.updateChartData(seriesData, labelsData);
                        } else {
                            // toast.error("No valid data to update chart");
                            this.series = [];
                            this.existingChartOptions = {
                                ...this.existingChartOptions,
                                labels: [],
                                colors: [],
                            };
                        }
                        const data = this.getZakatData?.lastCalculate;
                        if (data) {
                            this.lastCalculateFormatted = this.formatDateToDDMMMYYYY(data);
                        }

                    })
                } catch (e) {
                    console.error(e.response?.data)
                }

            },
            formatDateToDDMMMYYYY(isoString) {
                const date = new Date(isoString);
                const day = String(date.getDate()).padStart(2, '0');
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                const month = monthNames[date.getMonth()];
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            },
            getTotalLines() {
                return this.wasiyyahPreviewOptions.reduce(
                    (sum, item) => sum + item.content.split("\n").length + 4, // Count lines properly
                    0);
            },
            /*getPropertyData() {
                apiRepository.getPropertyDistribute().then((res) => {
                    if (res) {
                        this.propertyDistributionData = res.data;
                        let seriesData = [];
                        let labelsData = [];
                        seriesData = this.propertyDistributionData.map((item) => {
                            const portionPart = this.castToInteger(item.portion_part);

                            // console.log('kire kire', portionPart);
                            if (isNaN(portionPart) || portionPart === null) {
                                console.error("Invalid portion part:", item.portion_part);
                                return 0; // Default to 0 if invalid
                            }
                            return portionPart;
                        });

                        labelsData = this.propertyDistributionData.map((item) => {
                            const relativeName = item.relative_name || "Unknown";
                            return relativeName;
                        });

                        // Check if data is valid before updating the chart
                        if (seriesData.length > 0 && labelsData.length > 0) {
                            this.updateChartData(seriesData, labelsData);
                        } else {
                            console.error("Invalid series or labels data");
                            toast.error("No valid data to update chart");
                            this.series = [];
                            this.existingChartOptions = {
                                ...this.existingChartOptions,
                                labels: [],
                                colors: [],
                            };
                        }
                    }
                }).catch((error) => {
                    console.error(error.response?.data);
                })
            },*/
            generateColors(length) {
                const colors = [];
                for (let i = 0; i < length; i++) {
                    let color = `#${Math.floor(Math.random() * 16777215).toString(16)}`; // Random color
                    while (color.length !== 7) {
                        color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
                    }
                    colors.push(color);
                }
                return colors;
            },

            updateChartData(seriesData, labelsData) {
                if (
                    !Array.isArray(seriesData) ||
                    !Array.isArray(labelsData) ||
                    seriesData.length === 0 ||
                    labelsData.length === 0
                ) {
                    console.error("Invalid seriesData or labelsData");
                    return;
                }
                this.series = seriesData; // Update series with the data
                //  this.chartOptions.labels = labelsData; // Update labels
                //  this.chartOptions.colors = this.generateColors(seriesData.length); // Generate random colors for each segment
                this.chartOptions = {
                    ...this.chartOptions,
                    labels: labelsData,
                    colors: this.generateColors(seriesData.length),
                };
                this.existingChartOptions = {
                    ...this.existingChartOptions,
                    labels: labelsData,
                    colors: this.generateColors(seriesData.length),
                };
            },

            getUserContextVerify(key) {
                apiRepository.getUserContext(key, true).then((res) => {
                    if (res) {
                        this.getTraceData = res.data;
                        this.key = res.data.map(item => item.name);
                        this.contextDataGet(key);
                    }
                }).catch((error) => {
                    console.error(error.response?.data);
                })
            },
            castToInteger(value) {
                if (value == null) return 0; // Handle null or undefined input

                // Convert value to a string for safe processing
                let valueStr = value.toString();

                // Replace Bengali numerals with English numerals
                valueStr = valueStr
                    .replace(/০/g, "0")
                    .replace(/১/g, "1")
                    .replace(/২/g, "2")
                    .replace(/৩/g, "3")
                    .replace(/৪/g, "4")
                    .replace(/৫/g, "5")
                    .replace(/৬/g, "6")
                    .replace(/৭/g, "7")
                    .replace(/৮/g, "8")
                    .replace(/৯/g, "9");

                const parsedValue = parseFloat(valueStr);

                // Return the result, ensuring it's a valid number
                return isNaN(parsedValue) ? 0 : parsedValue;
            },
            /* getPropertyDistributionResult() {
                 apiRepository.getPropertyDistribute().then((res) => {
                     if (res) {
                         toast.success(res.data)
                     }
                 })
             }*/
        }
    }

</script>

<style>
    .heading img {
        width: 60%;
    }

    .border {
        border: 1px solid #ddd;
        padding: 20px;
    }

    hr.style-eight {
        overflow: visible; /* For IE */
        padding: 0;
        border: none;
        border-top: medium double #ffffff;
        color: #ffffff;
        max-width: 50%;
        text-align: center;
    }

    hr.style-eight:after {
        content: "§";
        display: inline-block;
        position: relative;
        top: -0.9em;
        font-size: 1.5em;
        padding: 0 0.25em;
        background: #2b2727;
    }

    hr.style-seven {
        overflow: visible; /* For IE */
        height: 30px;
        max-width: 220px;
        border-style: solid;
        border-color: #009155;
        border-width: 1px 0 0 0;
        border-radius: 20px;
    }

    hr.style-seven:before { /* Not really supposed to work, but does */
        display: block;
        content: "";
        height: 30px;
        margin-top: -31px;
        border-style: solid;
        border-color: #009155;
        border-width: 0 0 1px 0;
        border-radius: 20px;
    }

    hr.style-six {
        overflow: visible; /* For IE */
        height: 30px;
        max-width: 320px;
        border-style: solid;
        border-color: #009155;
        border-width: 1px 0 0 0;
        border-radius: 20px;
    }

    hr.style-six:before { /* Not really supposed to work, but does */
        display: block;
        content: "";
        height: 30px;
        margin-top: -31px;
        border-style: solid;
        border-color: #009155;
        border-width: 0 0 1px 0;
        border-radius: 20px;
    }

    .first-hr {
        background: #fff;
        width: 350px;
        border: 0;
        border-bottom: 1px dashed #ccc;
        background: #999;
    }

    .rounded {
        position: relative;
        background: none;
    }

    .rounded::before {
        content: ""; /* Create a pseudo-element for the background */
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url("@/assets/images/background.png");
        background-repeat: no-repeat;
        background-size: cover;
        opacity: 0.2; /* Apply opacity only to the background */
        /* z-index: -1;*/ /* Place it behind the content */
    }

    /*Barcode and QR code style*/
    .vertical-barcode {
        transform: rotate(270deg); /* Rotates the barcode 90 degrees to make it vertical */
        transform-origin: center; /* Ensures the rotation happens around the center */
    }

    /*Accordion Design*/
    /* Base icon style */
    .icon-toggle {
        transition: transform 0.3s ease;
    }

    /* When the accordion is expanded, switch icon */
    .accordion-button:not(.collapsed) .icon-toggle::before {
        content: "\f068"; /* Font Awesome minus */
        font-family: "Font Awesome 6 Free";
        font-weight: 900;
    }

    /* When the accordion is collapsed, show plus */
    .accordion-button.collapsed .icon-toggle::before {
        content: "\f067"; /* Font Awesome plus */
        font-family: "Font Awesome 6 Free";
        font-weight: 900;
    }

</style>